declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../src/app/ncs/models/api_response_model';
import { ApiRequestModel } from '../../../src/app/ncs/models/api_request_model';
import { SpinnerService } from '../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../src/app/ncs/models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { xLoginResponse } from '../../../src/app/ncs/models/login/loginresponsemodel';
import { LoginRequest, AppUserSettingRequest, AppUserSettingInfoController } from '../../../src/app/ncs/models/login/loginrequestmodel';
import { NGXToastrService } from '../../../src/app/shared/services/toastr.service';
import { LoginService } from '../../../src/app/ncs/services/login.service';
import { HCPService } from '../../../src/app/ncs/services/hcp.service';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController }
  from '../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../src/app/ncs/models/actor/actor';

import * as alertFunctions from '../../../src/app/shared/data/sweet-alerts';

import sha1Hex from 'sha1-hex';

//import MD5 from 'src/app/shared/utils/md5';


import { ThemeService, AppTheme } from '../../../src/app/ncs/services/theme.service';

@Component({
  selector: 'branchrole',
  templateUrl: './branchrole.component.html',
  styleUrls: ['./branchrole.component.scss']
})

export class SelBranchRoleComponent implements OnInit {

  @ViewChild('f') loginForm: NgForm;
  public logo: string = "";
  public BgImg: string = "";
  public logowidth: number;
  public logoheight: number;
  public UserName: string;
  CurrentLoginResponse: xLoginResponse;
  CurrentLoginRequest: LoginRequest;
  public isRequesting: boolean = false;
  public IncialLogin: xLoginResponse
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel;

  CurrentAppUserSettingRequest: AppUserSettingRequest;

  CurrentAppUserSettingInfoController: AppUserSettingInfoController;


  public IncialApiResData: ApiResponseModel


  constructor(
    private loaderService: SpinnerService,
    private tosterservice: NGXToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private loginservice: LoginService,
    private modalService: NgbModal,
    private hcpservice: HCPService,
    public themeService: ThemeService
  ) { }

  get currentTheme(): string {
    return this.themeService.currentTheme;
  }

  get themes(): AppTheme[] {
    return this.themeService.themes;
  }

  selectTheme(themeId: string) {
    this.themeService.setTheme(themeId);
  }
  ActorCode: number;
  Branch: any;
  Role: any;
  ngOnInit() {
    const userDetails: any = AppData.Instance().UserLoginDetails || {};
    this.ActorCode = userDetails.ActorCode || userDetails.actorCode || 6;
    this.Branch = userDetails.FacilityName || userDetails.facilityName || '';
    this.Role = userDetails.RoleName || userDetails.roleName || '';
    this.CurrentLoginResponse = new xLoginResponse();
    this.CurrentLoginRequest = new LoginRequest();
    const cas = AppData.Instance().cas;
    this.logo = (cas && cas.Navlogo) ? cas.Navlogo : "Navlogo.png";
    this.BgImg = (cas && cas.BckgImg) ? cas.BckgImg : "BckgImg.png";
    this.logowidth = (cas && cas.HlogoWidth) ? cas.HlogoWidth : 150;
    this.logoheight = (cas && cas.HlogoHeight) ? cas.HlogoHeight : 50;
    this.UserName = userDetails.UserName || userDetails.userName || 'admin';
    //if (AppData.Instance().IsSessionExits === true) {

    //  localStorage.clear();
    //  AppData.Instance().UserLoginDetails = this.IncialLogin;
    //  this.ApiResData = this.IncialApiResData;
    //}
    //this.tosterservice.clearToast();
    //this.CurrentLoginResponse = new xLoginResponse();
    //this.CurrentLoginRequest = new LoginRequest();

    //this.CurrentLoginRequest.RequestMode = 'WEB';
    //this.CurrentLoginRequest.RequestType = 1;

    //this.ApiReqData = new ApiRequestModel();
    //this.ApiReqData.xRequestType = 1;

    //this.CurrentAppUserSettingRequest = new AppUserSettingRequest();
    //this.CurrentAppUserSettingInfoController = new AppUserSettingInfoController();


  }
  onSubmit2() {
    this.loginservice
      .xGetProfileSettings(AppData.Instance().SelectedBranchCode.toString())
      .subscribe(v => {
        //AppData.GlobalApiUrl = v.GlobalApiUrl;
        //this.logo = v.Hlogo;
        AppData.Instance().cas = v;
      });
    this.router.navigate(['healins/latestdashboard2'])
  }

  onSubmit() {
   this.FindWhereToGo();


  }
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

  public ApiResData_profile: ApiResponseModel;
  NurseActorCode: number = 0;
  FindWhereToGo() {
    this.loginservice
      .xGetProfileSettings(AppData.Instance().SelectedBranchCode.toString())
      .subscribe(v => {
        //AppData.GlobalApiUrl = v.GlobalApiUrl;
        //this.logo = v.Hlogo;
        AppData.Instance().cas = v;
      });
    //AppData.Instance().cas.g

    //alertFunctions.AlertParam("nurse user.. ")
    //this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    //this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode; //this.CurrentAppUserSettingRequest.ActorCode;
    //this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.GetActorPersonalDetailInfoController();
    //this.stopRefreshing();
    //this.router.navigate(['branchrole']);
  //  if (this.SelectedBranchCode == 0 || this.SelectedFacilityCode==0)

    /// NEED TO CHANGE THIS NAVIGATION.. ERANKI: 01dec2021
    //this.router.navigate(['healins/ivfworkbench']);
    //this.router.navigate(['healins/latestdashboard']);
    //alert('Find Where to Go: to screen of: ' + AppData.Instance().SelectedRoleName);

    this.router.navigate(['healins/latestdashboard']);

    //if (AppData.Instance().SelectedRoleName ==  'Doctor') 
    //  this.router.navigate(['healins/docdashboard']);    
    //else
    //  this.router.navigate(['healins/latestdashboard']);
    //this.router.navigate(['healins/newdashboard']);
  }
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData_profile = result;
        if (!this.ApiResData_profile.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData_profile.Result[0];


          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          this.stopRefreshing();

          if (this.CurrentActorPersonalDetailInfoController.ProfileTitle.length > 0 ||
            this.CurrentActorPersonalDetailInfoController.ProfileSummary.length > 0
          ) {
            this.router.navigate(['nurse/dashboard']);
          }
          else {
            this.router.navigate(['nurse/profile']);
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData_profile.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData_profile.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onFacilitySelected(event: any) {

    alert(event.Code);

  }
  SelectedBranchCode: number;
  onAssignedToActorCode(event: any) {
    
    if (event != null) {

      AppData.Instance().SelectedBranchCode = this.SelectedBranchCode;// this.SelectedFacilityCode;
      AppData.Instance().UserLoginDetails.EmpFacilityCode = this.SelectedBranchCode;
      AppData.Instance().UserLoginDetails.FacilityName = event;
      //alert(AppData.Instance().UserLoginDetails.FacilityName);
      //alert(this.SelectedBranchCode);
     AppData.Instance().SelectedBranchName = event;
     // alert(event);
    }

  }
  SelectedFacilityCode: number;
  Roleassign(event: any) {

    if (event != null) {
      //alert(event);
      AppData.Instance().SelectedFacilityCode = this.SelectedFacilityCode;
      //alert(AppData.Instance().SelectedFacilityCode);
      AppData.Instance().SelectedFacilityName = event;
      //alert('Role Assign ' + AppData.Instance().SelectedFacilityName);
        AppData.Instance().SelectedRoleName = AppData.Instance().SelectedFacilityName;
      //alert(AppData.Instance().SelectedFacilityName);
    }

  }
  // On Forgot password link click
  onForgotPassword() {

    this.router.navigate(['forgotpassword']);


    //this.activeModal.close();
    //let options: NgbModalOptions = {
    //  windowClass: 'center-dialog',
    //  backdrop: 'static',
    //  keyboard: false
    //};
    //const modalRef = this.modalService.open(NgbForgetPWDModal, options)

  }
  // On registration link click
  onRegister() {

    //this.router.navigate(['register']);
  }
  //
  GetAppUserSettingInfoController() {
    this.StartRefreshing();
    this.loginservice.GetAppUserSettingInfoController(this.CurrentAppUserSettingRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentAppUserSettingInfoController = this.ApiResData.Result;
          AppData.Instance().AppUserSettingInfo = this.ApiResData.Result;
          // console.log(';;;;;;;;;;;' + this.CurrentAppUserSettingInfoController.FacilityConfigParamController[0].ConfigParamValue) 
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  




}
